export default "__VITE_ASSET__DsIUEdpI__"